export const PAYMENT_SOURCE_TYPE = {
    CARD: 'card',
    BANK_ACCOUNT: 'bank_account',
    CHECKOUT: 'checkout',
};
export const FORM_FIELD = {
    CARD_NAME: 'card_name',
    CARD_NUMBER: 'card_number',
    EXPIRE_MONTH: 'expire_month',
    EXPIRE_YEAR: 'expire_year',
    CARD_CCV: 'card_ccv',
    ACCOUNT_NAME: 'account_name',
    ACCOUNT_BSB: 'account_bsb',
    ACCOUNT_NUMBER: 'account_number',
    ACCOUNT_ROUTING: 'account_routing',
    ACCOUNT_HOLDER_TYPE: 'account_holder_type',
    ACCOUNT_BANK_NAME: 'account_bank_name',
    ACCOUNT_TYPE: 'account_type',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    EMAIL: 'email',
    PHONE: 'phone',
    PHONE2: 'phone2',
    ADDRESS_LINE1: 'address_line1',
    ADDRESS_LINE2: 'address_line2',
    ADDRESS_STATE: 'address_state',
    ADDRESS_COUNTRY: 'address_country',
    ADDRESS_CITY: 'address_city',
    ADDRESS_POSTCODE: 'address_postcode',
    ADDRESS_COMPANY: 'address_company',
};
export const STYLE = {
    BACKGROUND_COLOR: 'background_color',
    BACKGROUND_ACTIVE_COLOR: 'background_active_color',
    TEXT_COLOR: 'text_color',
    BORDER_COLOR: 'border_color',
    ICON_SIZE: 'icon_size',
    BUTTON_COLOR: 'button_color',
    ERROR_COLOR: 'error_color',
    SUCCESS_COLOR: 'success_color',
    FONT_SIZE: 'font_size',
    FONT_FAMILY: 'font_family',
};
export const VAULT_DISPLAY_STYLE = {
    BACKGROUND_COLOR: 'background_color',
    TEXT_COLOR: 'text_color',
    BORDER_COLOR: 'border_color',
    BUTTON_COLOR: 'button_color',
    FONT_SIZE: 'font_size',
    FONT_FAMILY: 'font_family',
};
export const TEXT = {
    TITLE: 'title',
    TITLE_H1: 'title_h1',
    TITLE_H2: 'title_h2',
    TITLE_H3: 'title_h3',
    TITLE_H4: 'title_h4',
    TITLE_H5: 'title_h5',
    TITLE_H6: 'title_h6',
    FINISH: 'finish_text',
    TITLE_DESCRIPTION: 'title_description',
    SUBMIT_BUTTON: 'submit_button',
    SUBMIT_BUTTON_PROCESSING: 'submit_button_processing',
};
export const ELEMENT = {
    SUBMIT_BUTTON: 'submit_button',
    TABS: 'tabs',
};
export const SUPPORTED_CARD_TYPES = {
    AMEX: 'amex',
    AUSBC: 'ausbc',
    DINERS: 'diners',
    DISCOVER: 'discover',
    JAPCB: 'japcb',
    LASER: 'laser',
    MASTERCARD: 'mastercard',
    SOLO: 'solo',
    VISA: 'visa',
    VISA_WHITE: 'visa_white',
};
export const SUPPORTED_CHECKOUT_META_COLLECTION = [].concat([
    'brand_name',
    'cart_border_color',
    'reference',
    'email',
    'hdr_img',
    'logo_img',
    'pay_flow_color',
    'first_name',
    'last_name',
    'address_line',
    'address_line2',
    'address_city',
    'address_state',
    'address_postcode',
    'address_country',
    'phone',
    'hide_shipping_address',
], [
    'first_name',
    'last_name',
    'phone',
    'tokenize',
    'email',
    'gender',
    'date_of_birth',
    'charge',
    'statistics',
    'hide_shipping_address',
], [
    'amount',
    'currency',
    'email',
    'first_name',
    'last_name',
    'address_line',
    'address_line2',
    'address_city',
    'address_state',
    'address_postcode',
    'address_country',
    'phone',
], [
    'customer_storage_number',
    'tokenise_algorithm',
]);
export var WALLET_GATEWAY;
(function (WALLET_GATEWAY) {
    WALLET_GATEWAY["STRIPE"] = "Stripe";
    WALLET_GATEWAY["FLYPAY"] = "Flypay";
    WALLET_GATEWAY["PAYPAL"] = "Paypal";
    WALLET_GATEWAY["MASTERCARD"] = "MasterCard";
})(WALLET_GATEWAY || (WALLET_GATEWAY = {}));
export var WALLET_TYPE;
(function (WALLET_TYPE) {
    WALLET_TYPE["GOOGLE"] = "google";
    WALLET_TYPE["APPLE"] = "apple";
    WALLET_TYPE["FLYPAY"] = "flypay";
    WALLET_TYPE["PAYPAL"] = "paypal";
})(WALLET_TYPE || (WALLET_TYPE = {}));
//# sourceMappingURL=../../src/lib/components/param.js.map